import bigInt from "big-integer";

const base62Chars =
  "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";

// Base62 Encoding
const base62Encode = (num) => {
  let result = "";
  while (num > 0) {
    result = base62Chars[num % 62] + result;
    num = Math.floor(num / 62);
  }
  return result || "0";
};

// Base62 Decoding
const base62Decode = (str) => {
  return str
    .split("")
    .reduce((acc, char) => acc * 62 + base62Chars.indexOf(char), 0);
};

// Function to Encrypt (String to Base62) without BigInt
export const encryptToBase62 = (text) => {
  // Convert to Padded ASCII
  const paddedAscii = Array.from(text)
    .map((char) => char.charCodeAt(0).toString().padStart(4, "0"))
    .join("");

  // Split padded ASCII into chunks that fit within Number limits
  const chunkSize = 15; // Ensure chunks fit within safe integer range
  const chunks = paddedAscii.match(new RegExp(`.{1,${chunkSize}}`, "g"));

  // Convert each chunk to Base62
  return chunks.map((chunk) => base62Encode(Number(chunk))).join("-");
};

// Function to Decrypt (Base62 to String) without BigInt
export const decryptFromBase62 = (base62String) => {
  // Split Base62 chunks
  const chunks = base62String.split("-");

  // Decode each chunk from Base62 and pad it
  const paddedAscii = chunks
    .map((chunk) => String(base62Decode(chunk)).padStart(15, "0"))
    .join("")
    .replace(/^0+/, ""); // Remove leading zeroes

  // Convert Padded ASCII back to Original Text
  const chars = [];
  for (let i = 0; i < paddedAscii.length; i += 4) {
    const code = parseInt(paddedAscii.slice(i, i + 4), 10);
    chars.push(String.fromCharCode(code));
  }
  return chars.join("");
};

export const simpleBase62Encode = (num) => {
  const chars =
    "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
  let result = "";
  while (num > 0) {
    result = chars[num % 62] + result;
    num = Math.floor(num / 62);
  }
  return result;
};

export const simpleBase62Decode = (str) => {
  if (typeof str === "string") {
    console.log("encryption str", str);
    const chars =
      "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
    const decoded = str
      .split("")
      .reduce((acc, char) => acc * 62 + chars.indexOf(char), 0);
    return String(decoded); // Ensure the result is a string
  } else {
    return;
  }
};

// Replace BigInt with bigInt
// export const simpleBase62EncodeString = (str) => {
//   const chars =
//     "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";

//   // Convert string to a large number
//   const asciiNumber = Array.from(str)
//     .map((char) => char.charCodeAt(0).toString().padStart(3, "0")) // Pad ASCII to 3 digits
//     .join(""); // Join to create a large number string

//   let num = bigInt(asciiNumber); // Use bigInt instead of BigInt

//   let result = "";
//   while (num.gt(0)) {
//     // .gt() is 'greater than' method for bigInt
//     result = chars[num.mod(62).toJSNumber()] + result; // .mod() is 'modulus' method for bigInt
//     num = num.divide(62);
//   }

//   return result || "0";
// };

export const simpleBase62EncodeString = (str) => {
  const chars =
    "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";

  // Convert string to a large number (supports Unicode)
  const unicodeNumber = Array.from(str)
    .map((char) => char.codePointAt(0).toString().padStart(5, "0")) // Use 5 digits for Unicode
    .join("");

  let num = bigInt(unicodeNumber);

  let result = "";
  while (num.gt(0)) {
    result = chars[num.mod(62).toJSNumber()] + result;
    num = num.divide(62);
  }

  return result || "0";
};

// export const simpleBase62DecodeString = (base62String) => {
//   const chars =
//     "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";

//   let num = bigInt(0);
//   for (let char of base62String) {
//     num = num.multiply(62).add(bigInt(chars.indexOf(char)));
//   }

//   let asciiStr = num.toString();
//   if (asciiStr.length % 3 !== 0) {
//     asciiStr = asciiStr.padStart(
//       asciiStr.length + (3 - (asciiStr.length % 3)),
//       "0"
//     );
//   }

//   const charsArray = [];
//   for (let i = 0; i < asciiStr.length; i += 3) {
//     const asciiCode = parseInt(asciiStr.slice(i, i + 3), 10);
//     if (asciiCode > 0) charsArray.push(String.fromCharCode(asciiCode));
//   }

//   return charsArray.join("");
// };

export const simpleBase62DecodeString = (base62String) => {
  const chars =
    "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";

  let num = bigInt(0);
  for (let char of base62String) {
    num = num.multiply(62).add(bigInt(chars.indexOf(char)));
  }

  let unicodeStr = num.toString();
  if (unicodeStr.length % 5 !== 0) {
    unicodeStr = unicodeStr.padStart(
      unicodeStr.length + (5 - (unicodeStr.length % 5)),
      "0"
    );
  }

  const charsArray = [];
  for (let i = 0; i < unicodeStr.length; i += 5) {
    const unicodeCode = parseInt(unicodeStr.slice(i, i + 5), 10);
    if (unicodeCode > 0) charsArray.push(String.fromCodePoint(unicodeCode));
  }

  return charsArray.join("");
};
